import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderComponent } from './loader/loader.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ArrayFilterPipe } from './pipes/filter-by.pipe';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { FilterArray } from '../dashboard/pipes/filterArray.pipe';

@NgModule({
  imports: [
    CommonModule, FormsModule, TranslateModule
  ],
  declarations: [
    LoaderComponent, LimitToPipe, FilterArray, ArrayFilterPipe
  ],
  exports: [
    LoaderComponent, LimitToPipe, FilterArray, ArrayFilterPipe
  ]
})
export class SharedModule { }
